// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/zh-tw'
import { Notification, NotificationLink } from '../../../types/Model';
import ReadMarkIcon from './assets/read-mark.svg';
import S from './styles';
import { Link, useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
interface ButtonOptionProps {
  link: NotificationLink;
  notificationId: number
  readNotification: Function;
  closePopup: () => void;
}

const ButtonOptions = (props: ButtonOptionProps): JSX.Element => {
  const {
    link,
    readNotification,
    notificationId,
    closePopup
  } = props;

  const history = useHistory();
  const intl = useIntl();
  let linkPath = '/';
  let buttonLabel = '';
  switch (link.page) {
    case 'lab':
      linkPath = link.id ? `/labs/${link.id}` : '/labs';
      buttonLabel = '前往實驗'
      break;
    case 'course':
      linkPath = link.id ? `/onlineCourses/${link.id}` : '/onlineCourses';
      buttonLabel = '前往課程'
      break;
    case 'workshop':
      linkPath = `/workshops/${link.id}`;
      buttonLabel = '前往工作坊'
      break;
    case 'support':
      linkPath = `/support?id=${link.id}`;
      buttonLabel = intl.formatMessage({ id: 'H009' })
      break;
    case 'examReview':
      linkPath = `/examReview/${link.id}`;
      buttonLabel = intl.formatMessage({ id: 'H017' })
      break;
    case 'home':
    default:
      linkPath = '/home';
      buttonLabel = intl.formatMessage({ id: 'H003' });
      break
  }

  const clickFunction = async () => {
    // console.log({ notificationId })
    await readNotification({ id: notificationId });
    if (link.page === 'home' && link.id) {
      history.push({
        pathname: linkPath,
        state: { handsOnType: 'exam' }
      });
    } else if (link.page === 'examReview') {
      const url = `/examReview/${link.id}`;
      window.open(url);
    } else {
      history.push(linkPath);
    }
    closePopup()
  }

  return (
    <S.Button onClick={clickFunction}>
      {buttonLabel}
    </S.Button>
  )
}

interface NotificationProps extends React.ComponentPropsWithRef<'div'> {
  closePopup: () => void;
  bodyRef: React.MutableRefObject<HTMLDivElement | null>;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  isNotificationFetching: boolean;
  currentPage: number;
  notificationsList: Notification[];
  notificationsCount: number;
  getResetNotifications: Function;
  readNotification: Function;
}

const NotificationPopUp: React.FC<NotificationProps> = props => {
  const {
    closePopup,
    bodyRef,
    setCurrentPage,
    currentPage,
    notificationsList,
    isNotificationFetching,
    notificationsCount,
    getResetNotifications,
    readNotification,
    ...otherProps
  } = props;
  const now = new Date().getTime();
  const intl = useIntl();

  useEffect(() => {
    getResetNotifications();
    return () => {
      handleMouseLeaveTrigger();
    }
  }, []);

  const handleClickTrigger: React.MouseEventHandler = (e) => {
    e.stopPropagation();
  }

  // Prevent body scroll when scrolling on notification popup
  const handleMouseEnterTrigger = () => {
    if (bodyRef?.current) {
      bodyRef.current.style.overflow = 'hidden'
    }
  }

  const handleMouseLeaveTrigger = () => {
    if (bodyRef?.current) {
      bodyRef.current.style.overflow = ''
    }
  }

  const handleScroll: React.UIEventHandler = (e) => {
    const { currentTarget } = e;

    if (isNotificationFetching || notificationsCount === notificationsList.length) return;
    if (currentTarget.scrollTop + currentTarget.clientHeight === currentTarget.scrollHeight) {
      setCurrentPage(currentPage + 1);
    }
  }
  // console.log({ notificationsList });
  return (
    <S.NotificationWrapper
      onClick={handleClickTrigger}
      onMouseEnter={handleMouseEnterTrigger}
      onMouseLeave={handleMouseLeaveTrigger}
      {...otherProps}
    >
      <S.NotificationHeader alignX="between" alignY="center" >
        <S.NotificationTitle>{intl.formatMessage({ id: 'H001' })}</S.NotificationTitle>
      </S.NotificationHeader>
      <S.NotificationBody onScroll={handleScroll}>
        {
          !isNotificationFetching && notificationsList.length === 0 ? (
            <S.NotificationMessageContainer>
              <S.BellIcon />
              <S.NoNewText>{intl.formatMessage({ id: 'H013' })}</S.NoNewText>
            </S.NotificationMessageContainer>
          ) : (
            <S.NotificationListItems>
              {notificationsList.map((notif) => (
                <S.NotificationItemWrapper key={notif.id} isRead={notif.read}>
                  <S.ReadMarkWrapper>
                  </S.ReadMarkWrapper>
                  <S.NotificationItem >
                    <S.Message className="Item Text">
                      {/* {notif.message} */}
                      <FormattedMessage id={notif.notificationType} values={{ total: notif.notificationProps.total, name: notif.notificationProps.name, organizationName: notif.notificationProps.organizationName, hasReply: notif.notificationProps.hasReply, roleName: notif.notificationProps.roleName, examName: notif.notificationProps.examName, reviewee: notif.notificationProps.reviewee, br: <br /> }} />
                      <br />
                      <S.Time>{now - notif.time.getTime() <= 86400000 ? `${moment(notif.time).fromNow(true)}` + intl.formatMessage({ id: 'I026' }) : moment(notif.time).format('L')}</S.Time>
                    </S.Message>
                    {notif.link && <ButtonOptions link={notif.link} readNotification={readNotification} notificationId={notif.id} closePopup={closePopup} />}
                  </S.NotificationItem>
                </S.NotificationItemWrapper>
              ))}
              {isNotificationFetching && (
                <S.NotificationMessageContainer>
                  <S.LoadingIcon />
                  <S.LoadingText>{intl.formatMessage({ id: 'H014' })}...</S.LoadingText>
                </S.NotificationMessageContainer>
              )}
            </S.NotificationListItems>
          )
        }
      </S.NotificationBody>
    </S.NotificationWrapper>
  )
}

export { NotificationPopUp as default };
